/** Single place for the business details repeated across the page. */
export const CONTACT_EMAIL = 'info@bizvisiontech.com';
export const MAILTO = `mailto:${CONTACT_EMAIL}`;
export const ADDRESS = '1309 Coffeen Avenue STE 1200, Sheridan, Wyoming, 82801';
export const SOCIAL = {
  instagram: 'https://www.instagram.com/bizvisiontech/',
  linkedin: 'https://www.linkedin.com/company/bizvision-tech/',
};

export const NAV_LINKS = [
  { id: 'pillars', label: 'Services' },
  { id: 'process', label: 'How it works' },
  { id: 'why', label: 'Why us' },
  { id: 'contact', label: 'Contact' },
];
